/**
 * menuHorizontal.js
 */

// Import
import './menuHorizontal.scss';
import $ from 'jquery';
import 'bootstrap/js/dist/tooltip';

$(document).ready(function() {

    const $dropdown = $("#horizontal-menu .dropdown");
    const $dropdownToggle = $("#horizontal-menu .dropdown-toggle");
    const $dropdownMenu = $("#horizontal-menu .dropdown-menu");
    const showClass = "show";

    $dropdown.hover(
        function() {
            const $this = $(this);
            $this.addClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "true");
            $this.children($dropdownMenu).addClass(showClass);
        },
        function() {
            const $this = $(this);
            $this.removeClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "false");
            $this.children($dropdownMenu).removeClass(showClass);
        }
    );

    //$( "#user-menu li " ).find( "a" ).css( "color", "red" );D:\projets\gab-uiversel\html\wp-content\themes\401372-service-des-ressources-humaines-vradho
    //$('[data-toggle="tooltip"]').tooltip();
    $( "#user-menu li:first a" ).append( "<span class='interrogation'  data-toggle='tooltip' data-original-title='Connectez-vous à SIGA pour : modifier vos informations personnelles, obtenir vos feuillets fiscaux, consulter vos relevés de paie, etc.'> </span>" );
    $( "#user-menu li.menu-item-746 a" ).append( "<sup class='interrogation' data-toggle='tooltip' data-original-title='Cet onglet est exclusivement réservé aux membres du personnel cadre. Il contient des outils et des ressources pour aider les gestionnaires dans leurs fonctions.'></sup>" );

    $('[data-toggle="tooltip"]').tooltip();
});

